import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "chevron-right",
  "use": "chevron-right-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"chevron-right\"><path fill=\"currentColor\" d=\"M5.11 21.47L14.58 12 5.11 2.53 7.64 0l10.73 10.74a1.77 1.77 0 0 1 0 2.52L7.64 24z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol